var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.905397 14.9011C0.694647 14.9011 0.484062 14.8207 0.3232 14.6599C0.00164164 14.3385 0.00164164 13.8172 0.3232 13.4958L13.4951 0.323916C13.8163 0.00252204 14.3379 0.00252204 14.6591 0.323916C14.9807 0.645474 14.9807 1.16675 14.6591 1.48814L1.48726 14.66C1.32673 14.8207 1.11615 14.9011 0.905397 14.9011Z",
    fill: "#13497B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0771 14.9008C13.8665 14.9008 13.6556 14.8204 13.4951 14.6596L0.3232 1.48769C0.00164164 1.16613 0.00164164 0.644852 0.3232 0.323458C0.644758 0.00206428 1.16587 0.00206428 1.48743 0.323458L14.6593 13.4953C14.9809 13.8167 14.9809 14.338 14.6593 14.6594C14.4986 14.8204 14.2877 14.9008 14.0771 14.9008Z",
    fill: "#13497B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.d6c116f650ae8a6658acce594e1221b7.svg";
export { ForwardRef as ReactComponent };